import React from 'react';
import { AntdSkeleton, AntdSpace } from '@ui';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  size?: number;
  takeWholePage?: boolean;
}

const getSpaceStyles = (takeWholePage: boolean) => ({
  gap: '8px',
  marginTop: '10px auto 0',
  width: '100%',
  justifyContent: 'center',
  height: takeWholePage ? '100vh' : 'auto',
});

export const Spinner = ({ takeWholePage = false, className, size, ...props }: SpinnerProps) => {
  return (
    <AntdSpace direction="horizontal" style={getSpaceStyles(takeWholePage)} {...props}>
      {[...Array(3)].map((_, i) => (
        <AntdSkeleton.Avatar
          key={i}
          active={true}
          size={size ?? 12}
          className={`flex items-center justify-center ${className}`}
        />
      ))}
    </AntdSpace>
  );
};
